import React from 'react';

export default function NoTranslateText({
  as: Component = 'span',
  text = '',
  className = '',
  children,
  ...props
}) {
  const classes = ['notranslate', className].filter(Boolean).join(' ');
  const content = typeof children !== 'undefined' ? children : text;

  return (
    <Component translate="no" className={classes} {...props}>
      {content}
    </Component>
  );
}
